const CompleteIconSvg = (props: any) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={42} height={42} {...props}>
		<defs>
			<clipPath id='b'>
				<path
					fill='#fff'
					stroke='#707070'
					d='M290 924h16v16h-16z'
					data-name='Rect\xE1ngulo 84608'
				/>
			</clipPath>
			<filter id='a' width={42} height={42} x={0} y={0} filterUnits='userSpaceOnUse'>
				<feOffset dy={3} />
				<feGaussianBlur result='blur' stdDeviation={3} />
				<feFlood floodOpacity={0.161} />
				<feComposite in2='blur' operator='in' />
				<feComposite in='SourceGraphic' />
			</filter>
		</defs>
		<g data-name='Grupo 18640'>
			<g filter='url(#a)' transform='translate(-.002)'>
				<circle
					cx={12}
					cy={12}
					r={12}
					fill='#fff'
					data-name='Elipse 1511'
					transform='translate(9 6)'
				/>
			</g>
			<g clipPath='url(#b)' data-name='Enmascarar grupo 15359' transform='translate(-277 -914)'>
				<path
					fill='#f30f70'
					d='M296.136 937.011a1.157 1.157 0 0 1-.818-.338l-3.855-3.855a1.157 1.157 0 0 1 1.636-1.636l3.037 3.038 6.506-6.507a1.157 1.157 0 0 1 1.636 1.636l-7.324 7.325a1.157 1.157 0 0 1-.818.338Z'
					data-name='Trazado 37102'
				/>
			</g>
		</g>
	</svg>
)
export default CompleteIconSvg
